export default "__VITE_ASSET__CCoJVR6H__"